"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("@react-google-maps/api");
const react_1 = __importStar(require("react"));
const components_common_map_pin_1 = require("@hotelplan/components.common.map-pin");
const MapRadiusSearchAutocomplete_1 = __importDefault(require("./MapRadiusSearchAutocomplete"));
function MapRadiusSearchFilter({ radiusFilter, onChange, pinOfInterestIcon, }) {
    const map = (0, api_1.useGoogleMap)();
    const [place, setPlace] = (0, react_1.useState)(() => {
        if (!radiusFilter)
            return undefined;
        return {
            coordinates: radiusFilter.center,
            name: radiusFilter.label,
        };
    });
    const [radius, setRadius] = (0, react_1.useState)(radiusFilter === null || radiusFilter === void 0 ? void 0 : radiusFilter.radius);
    (0, react_1.useEffect)(function centerPlaceOnInit() {
        if (radiusFilter) {
            map.setCenter((0, components_common_map_pin_1.mapCoordinatesToLatLng)(radiusFilter.center));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, react_1.useEffect)(function clearPlaceWhenFilterIsRemoved() {
        if (!radiusFilter && place) {
            setPlace(undefined);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [radiusFilter]);
    function handleOnChange(nextValue) {
        const { place: nextPlace, radius: nextRadius } = nextValue;
        setRadius(nextRadius);
        setPlace(nextPlace);
        onChange === null || onChange === void 0 ? void 0 : onChange(nextPlace, nextRadius);
    }
    return (react_1.default.createElement(MapRadiusSearchAutocomplete_1.default, { value: { radius, place }, onChange: handleOnChange, pinOfInterestIcon: pinOfInterestIcon }));
}
exports.default = MapRadiusSearchFilter;
//# sourceMappingURL=MapRadiusSearchFilter.js.map